import { UserMemberStatusDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum UserMemberStatusEventTypes {
  USER_MEMBER_STATUS_CREATED = '[Member Status] UserMemberStatus Created',
  USER_MEMBER_STATUS_DELETED = '[Member Status] UserMemberStatus Deleted',
}

/**
 * Payloads
 */
export interface UserMemberStatusWSPayload {
  userMemberStatus: UserMemberStatusDto;
}
export interface UserMemberStatusDeletedWSPayload {
  userMemberStatusId: number;
  memberId: string;
}

/**
 * Events
 */
export class UserMemberStatusWSMessage {
  type: string;
  constructor(public payload: UserMemberStatusWSPayload) {
    this.type = UserMemberStatusEventTypes.USER_MEMBER_STATUS_CREATED;
  }
}
export class UserMemberStatusWSDeletedMessage {
  type: string;
  constructor(public payload: UserMemberStatusDeletedWSPayload) {
    this.type = UserMemberStatusEventTypes.USER_MEMBER_STATUS_DELETED;
  }
}
